export const createDistributorApis = instance => ({
  home: identifier => {
    return instance.get(`/distributor/salesPage?identifier=${identifier}`, { headers: { NoPassToken: true } })
  },
  getProduct: (id,identifier)=>{
    return instance.get(`/distributor/productDetail?productId=${id}&identifier=${identifier}`)
  }
})

